import { List, ListItemButton, ListItemText } from "@mui/material";

export const MenuList = ({ itemList, onItemSelected }) => {

    const handleNavigate = (item) => {
        onItemSelected(item.url, item.breadcrumbName);
    };

    return (
        <List component="div" disablePadding>
            {
                itemList.map((item, index) => (
                    <ListItemButton key={item.name}
                    className="innerHamburgerMenu"
                        sx={{
                            color: "primary.contrastText",
                            "&:hover": { backgroundColor: "primary.main" },
                            backgroundColor: "primary.main",
                            pl: 5,
                        }}
                        onClick={() => {
                            handleNavigate(item);
                        }}
                    >
                        <ListItemText primary={item.name} />
                    </ListItemButton>
                ))
            }
        </List>

    )
}